import routes from '@/modules/complain-type/complain-type-routes';
import store from '@/modules/complain-type/complain-type-store';

export default {
    routes,
    store,
}
